
import { mapState, mapActions } from "vuex";
import {
minBaseOptions1,
minBaseOptions2,
resetTextBylangKey,
} from "../../../libs/options.js";
import Badge from 'vux/src/components/badge/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
components: { Badge, Group, Cell },
inject: ["parentCom"],
data() {
return {
securityCodeSrc: "",
};
},
computed: {
...mapState({
assetsInfoMap: (state) => state.userInfo.assetsInfoMap,
accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
userName: (state) => state.userInfo.userInfo.userAccount,
isLogin: (state) => state.isLogin,
UUID: (state) => state.UUID,
Download_url: (state) => state.Download_url,
FrontConfigList: (state) => state.FrontConfigList,
}),
minBaseOptions1() {
return resetTextBylangKey(
minBaseOptions1,
this.$t("mine").minBaseOptions1
);
},
minBaseOptions2() {
return resetTextBylangKey(
minBaseOptions2,
this.$t("mine").minBaseOptions2
);
},
},
created() {

},
methods: {
...mapActions(["getFirstInfo"]),
toNew() {

this.$router.push({
path: "/NewMy",
});
},
handleGoDiffPath({ langKey, path }) {

const keys = ["agentCenter", "appDownload"];
if (langKey === "agentCenter")
window.open(this.FrontConfigList.agent_url + path);
if (langKey === "appDownload") window.open(this.Download_url);
console.log(path);
if (!keys.includes(langKey)) this.$router.push({ path });
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/bak.index.vue